import React from 'react'
import CustomersContext from '../context/CustomerHubContext'
import PropTypes from 'prop-types'

function CustomersHubProvider(props) {
    const {getCustomers} = props

    return (
        <CustomersContext.Provider
            value={{
                getCustomers,
            }}
        >
            {props.children}
        </CustomersContext.Provider>
    )
}

CustomersHubProvider.propTypes = {
    getCustomers: PropTypes.func.isRequired
}

export default CustomersHubProvider
